import en from "./en";
import ja from "./ja";

const question = {
  en,
  ja
}

export default question;